import { useSearchParams } from "react-router-dom"

type DefaultParams = {
  [key: string]: any | null
}

export const useCurrentSearchParams = (
  defaultParams: DefaultParams = {},
): [DefaultParams, (nextParams: DefaultParams) => void] => {
  const [searchParams, setSearchParams] = useSearchParams()
  const params = Object.fromEntries([...searchParams])

  let currentParams = {
    ...defaultParams,
    ...params,
  }

  Object.keys(defaultParams).forEach((key) => {
    if (defaultParams[key] === null && !(key in params)) {
      delete currentParams[key]
    }
  })

  currentParams = Object.keys(currentParams).reduce((acc, key) => {
    acc[key] = String(currentParams[key])
    return acc
  }, {} as DefaultParams)

  const updateParams = (nextParams: DefaultParams) => {
    setSearchParams(() => ({ ...currentParams, ...nextParams }))
  }

  return [currentParams, updateParams]
}
